import Svg, { Path, Rect } from 'react-native-svg';

/**
 * Blue check-in-circle used for the bio sheet's qualification / license items
 * (matches the vida-design-system demo's inline CheckIcon).
 */
export function CheckIcon({ size = 24 }: { size?: number }) {
  return (
    <Svg width={size} height={size} viewBox='0 0 20 20' fill='none'>
      <Rect width={20} height={20} rx={10} fill='#DFEDFB' />
      <Path
        d='M14.2128 5.66268C13.9634 5.48392 13.6164 5.54112 13.4376 5.79046L8.23943 13.0379L6.50424 11.3012C6.36392 11.1608 6.15935 11.1059 5.96761 11.1573C5.77586 11.2086 5.62606 11.3583 5.57464 11.5501C5.52322 11.7418 5.57799 11.9464 5.71832 12.0868L7.91646 14.2845C8.03321 14.3969 8.19257 14.4537 8.35404 14.4405C8.51552 14.4273 8.66356 14.3454 8.76054 14.2156L14.3405 6.43787C14.5193 6.18852 14.4621 5.84147 14.2128 5.66268Z'
        fill='#0066CC'
      />
    </Svg>
  );
}
